import { render, staticRenderFns } from "./RecruiterIndex.vue?vue&type=template&id=2b399b6e&scoped=true"
import script from "./RecruiterIndex.vue?vue&type=script&lang=ts"
export * from "./RecruiterIndex.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterIndex.vue?vue&type=style&index=0&id=2b399b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b399b6e",
  null
  
)

export default component.exports